// apps/estelle/gpa.js — the GPA tracker's math (H·2). GPA is MANUAL-ENTRY per course: she picks a
// letter grade; nothing is computed from assignment scores (that needs weighting schemes her brief
// doesn't define — flagged as future). Estelle's GPA is the straight UNWEIGHTED average of course
// grade points — high school; weighted/AP scales are a junior-year concern, also future.
//
// The standard 4.0 map lives in core (X·3 — one owner; a scale correction was a two-copy fix);
// re-exported here so the server and the bundle keep their one import site.
import { GRADE_POINTS, GRADES } from "@school-apps/core/hub/grade-points";
export { GRADE_POINTS, GRADES };

/**
 * Unweighted GPA over the courses that have a grade entered; null when none do (graceful
 * "no grades yet" — never a fake 0.0).
 * @param {Array<{ grade?: string }>} courses
 * @returns {number|null}
 */
export function gpaOf(courses) {
  const graded = courses.filter((c) => typeof c.grade === "string" && c.grade in GRADE_POINTS);
  if (graded.length === 0) return null;
  return graded.reduce((sum, c) => sum + GRADE_POINTS[c.grade], 0) / graded.length;
}

/** Display form: two decimals, or an em-dash when there's nothing to average. */
export function fmtGpa(value) {
  return value === null ? "—" : value.toFixed(2);
}
